import { LocalStorage } from "@kernel/frontend-react-app";
import { StatsDto, StatsReportMap, StatsToDtoEntity } from "./dto";

export class StatsStoreService {
  private storage: LocalStorage<StatsDto>;
  constructor(private stats: StatsToDtoEntity) {
    this.storage = new LocalStorage();
  }

  public storeStats(stats: StatsReportMap): void {
    const statsDto = this.stats.toDto();
    statsDto.report = Object.fromEntries(stats);
    this.storage.set(this.stats.toString(), statsDto);
  }

  public getStats(): StatsDto {
    const storedReport = this.storage.get(this.stats.toString());
    if (storedReport === null) {
      throw new Error("No stats to get");
    }
    return storedReport;
  }

  public removeStats(): void {
    this.storage.remove(this.stats.toString());
  }
}
